import React from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, Button, Icon } from '@shopflo/ui'
import { Trash } from '@phosphor-icons/react'
import { useLocale } from 'src/lib/hooks/useLocal'

interface DeleteConfirmationPopupProps {
  isOpen: boolean
  actions: {
    onConfirm: () => void
    onClose: () => void
  }
  config: {
    confirmationText?: string
    description: string
    title: string
    isLoading?: boolean
  }
}

const DeleteConfirmationPopup = ({
  isOpen,
  actions,
  config: { confirmationText, description, title, isLoading = false }
}: DeleteConfirmationPopupProps) => {
  const { onConfirm, onClose } = actions
  const { t } = useLocale()

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className='bg-white max-w-[360px] !rounded-2xl p-5'>
        <DialogHeader>
          <DialogTitle>
            <div className='flex flex-col justify-center items-center gap-2'>
              <div className='h-11 w-11 flex items-center justify-center bg-red-50 rounded-xl'>
                <Icon IconComponent={Trash} size='lg' className='text-red-600' iconProps={{ weight: 'duotone' }} />
              </div>
            </div>
          </DialogTitle>
        </DialogHeader>
        <div className='flex flex-col justify-center items-center gap-2'>
          <div className='flex flex-col gap-2'>
            <div className='text-text-md-semibold text-zinc-800 text-center'>{title}</div>
            <div className='text-text-sm-regular text-zinc-500'>{description}</div>
          </div>
        </div>

        <DialogFooter>
          <Button variant='outline' onClick={onClose} size='md' className='w-full'>
            {t('cancel')}
          </Button>
          <Button variant='error' size='md' onClick={onConfirm} className='w-full' loading={isLoading}>
            {confirmationText || 'Yes, Proceed'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default DeleteConfirmationPopup
